
const generateTransactionId = (): string => {
  const timestamp = Date.now().toString(36);
  const random = Math.random().toString(36).substring(2, 10);
  return `txn_${timestamp}_${random}`;
};

export const trackTrendyolConversion = () => {
  if (typeof window.gtag === 'function') {
    const transactionId = generateTransactionId();
    window.gtag('event', 'conversion', {
      'send_to': 'AW-17940546624/v_XLCO-7_vQbEMCI3OpC',
      'transaction_id': transactionId,
    });
  }
};
